import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { IDR } from "@/lib/format";
import { Stat } from "@/components/Brand";
import { OpenState, CardTopRow, CardActions } from "@/components/dashboard/ProjectCardParts";

/** One gallery: status, batch checkbox, quota stats and the row actions. */
export const ProjectCard = ({ project: p, picked, locked, showInvoice, reminding, onPick, onDelete, onRemind, onCopyLink }) => {
  const { t } = useI18n();

  return (
    <div data-testid={`project-card-${p.project_id}`}
      className="bg-[#0F0F0F] border border-[#2A2A2A] p-7 hover:border-[#3d3a30] transition-colors duration-500 group">
      <CardTopRow project={p} picked={picked} locked={locked} onPick={onPick} onDelete={onDelete} />

      <Link to={`/projects/${p.project_id}`}>
        <p className="mt-6 font-mono-accent text-[11px] text-[#D4AF37]">{p.code}</p>
        <h3 className="mt-1 text-2xl tracking-tight hover:text-[#D4AF37] transition-colors">{p.title}</h3>
      </Link>
      <p className="mt-1 text-sm text-[#A8A8A8]">{p.client_name || "—"}</p>
      {p.status !== "submitted" && <OpenState project={p} />}

      <div className="mt-7 grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-3 border-t border-[#2A2A2A] pt-5">
        <Stat label={t("photos")} value={p.photo_count} />
        <Stat label={t("edits")} value={`${p.edit_selected - p.extra_edits}/${p.edit_quota}`} />
        <Stat label={t("extra")} value={p.extra_edits} accent={p.extra_edits > 0} />
        <Stat label={t("prints")} value={p.print_selected} />
      </div>

      {showInvoice && p.invoice_total != null && (
        <p className="mt-4 font-mono-accent text-xs text-[#D4AF37]" data-testid={`invoice-total-${p.project_id}`}>
          {t("invoice")}: {IDR(p.invoice_total)}
        </p>
      )}

      <CardActions project={p} reminding={reminding} onRemind={onRemind} onCopyLink={onCopyLink} />
    </div>
  );
};
